module.exports = __webpack_public_path__ + "img/ic-blokk.b2cb0152.svg";